export const formatMinAmount = (amount: number | undefined): string => {
  return amount && amount > 0 ? `$${amount}` : '$0';
};

export const formatMaxAmount = (amount: number | undefined): string => {
  return amount && amount > 0 ? `$${amount}` : '∞';
};
